/**
 * API: municipios — perfil, benchmark, autocomplete.
 *
 * Sprint 4 (benchmark Wow 3) + Sprint 7 (autocomplete) + Sprint 1 (perfil).
 * Extraído del antiguo `lib/api.ts` en Sprint 18.4.1.
 */

import type { MunicipalityProfileDTO } from "../types";
import { request } from "./_client";

export function fetchMunicipalityProfile(dane: string): Promise<MunicipalityProfileDTO> {
  return request<MunicipalityProfileDTO>(`/municipalities/${encodeURIComponent(dane)}/profile`);
}

// --- Benchmark (Sprint 4 Wow 3) ---

export interface SgrAggregateDTO {
  count: number;
  /** Monto total aprobado en COP (string numérico, puede ser "0"). */
  total_amount_cop: string;
}

export interface BenchmarkMetricsDTO {
  muni: SgrAggregateDTO;
  peer_avg: SgrAggregateDTO;
  peer_best: SgrAggregateDTO;
  count_rank: number;
  amount_rank: number;
}

export interface TopSectorDTO {
  sector: string;
  total_amount_cop: string;
  project_count: number;
}

export interface BenchmarkReportDTO {
  dane_code: string;
  name: string;
  department_name: string;
  category: string;
  peers_count: number;
  peer_group_definition: string;
  sgr_metrics: BenchmarkMetricsDTO;
  top_sectors_in_peer_group: TopSectorDTO[];
}

export function fetchMunicipalityBenchmark(dane: string): Promise<BenchmarkReportDTO> {
  return request<BenchmarkReportDTO>(`/municipalities/${encodeURIComponent(dane)}/benchmark`);
}

// --- Autocomplete / búsqueda (Sprint 7) ---

export interface MunicipalityListItemDTO {
  dane_code: string;
  name: string;
  department_name: string;
  region_sgr: string;
  category: string;
}

export function searchMunicipalities(q: string, limit = 20): Promise<MunicipalityListItemDTO[]> {
  const qs = new URLSearchParams({ q, limit: String(limit) });
  return request<MunicipalityListItemDTO[]>(`/municipalities?${qs.toString()}`);
}
